import { render, staticRenderFns } from "./CreatePayment.vue?vue&type=template&id=90e1818e&"
import script from "./CreatePayment.vue?vue&type=script&lang=js&"
export * from "./CreatePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports